import { render, staticRenderFns } from "./LabelTree.vue?vue&type=template&id=f37fe5ee&scoped=true"
import script from "./LabelTree.vue?vue&type=script&lang=js"
export * from "./LabelTree.vue?vue&type=script&lang=js"
import style0 from "./LabelTree.vue?vue&type=style&index=0&id=f37fe5ee&scoped=true&lang=scss"
import style1 from "./LabelTree.vue?vue&type=style&index=1&id=f37fe5ee&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37fe5ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f37fe5ee')) {
      api.createRecord('f37fe5ee', component.options)
    } else {
      api.reload('f37fe5ee', component.options)
    }
    module.hot.accept("./LabelTree.vue?vue&type=template&id=f37fe5ee&scoped=true", function () {
      api.rerender('f37fe5ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/LabelGroup/components/LabelTree.vue"
export default component.exports